import { Anchor, Button } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React from 'react'
import { Category } from 'stoux-shared-types/models/category'

const stripLeadingNumber = (title: string) => title.replace(/^\d{2}\s/, '')

type CategoryComponentProps = {
    category: Category
    onSelect: (id: string) => void
}

const CategoryComponent = ({ category, onSelect }: CategoryComponentProps) => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    const behaviorProps = {
        onClick: () => {
            if (!category.mpath) return
            onSelect(category.mpath)
            // window.location.href = `/search?category=${category.mpath}`
        },
        onMouseEnter: () => {
            if (!isDesktop) return
            if (!category.mpath) return

            onSelect(category.mpath)
        },
    }

    if (!category) return null

    return (
        <div
            style={{ textTransform: 'capitalize' }}
            className="flex items-center cursor-pointer justify-between w-max p-2 text-sm text-left capitalize text-neutral-500 hover:bg-neutral-100"
            {...behaviorProps}
        >
            <div className="flex flex-col w-max">
                <Anchor
                    href={`/search?category=${category.mpath}`}
                    color="gray.6"
                    className="text-sm tracking-tight font-medium underline whitespace-nowrap"
                >
                    {stripLeadingNumber(category.title)}
                </Anchor>
            </div>
            <Button
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation()
                    if (!category.mpath) return
                    onSelect(category.mpath)
                }}
                className="lg:hidden"
                size="xs"
                variant="white"
                color="gray"
            >
                &rarr;
            </Button>
        </div>
    )
}

export default CategoryComponent
